export const newState = (state) => {
    if (state === false) {
        return true
    } else {
        return false
    }
}